import React from 'react';
import styled from 'styled-components';
import {COLORS, ELEVATIONS, SIZES, Typography} from '@fupa/fupa-uikit';
import {InstagramEmbed} from 'react-social-media-embed';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.white};
  box-shadow: ${ELEVATIONS.Card};
  height: auto;
  margin-bottom: ${SIZES['16']};
  width: 100%;
  max-width: 30.75rem;
  border: 1px solid ${COLORS.black};
  padding: ${SIZES['16']};
  @media only screen and (max-width: 508px) {
    padding: ${SIZES['16']} ${SIZES['8']};
  }
`;

const CardHeader = styled.div`
  display: flex;
  padding-bottom: ${SIZES['12']};
`;

const ScalingTypography = styled(Typography)`
  &&& {
    margin: 0;
    font-weight: bold;
    @media only screen and (min-width: 492px) {
      font-size: ${SIZES['20']};
    }
  }
`;

const InfoCardEmbed = () => {
  return (
    <Wrapper>
      <CardHeader>
        <ScalingTypography variant='subheading' component='h3'>
          Rückblick auf das Event
        </ScalingTypography>
      </CardHeader>
      <InstagramEmbed
        url='https://www.instagram.com/reel/CvHzCWDLM0A/?utm_source=ig_web_copy_link'
        width='100%'
        maxWidth='500px'
      />
    </Wrapper>
  );
};

export default InfoCardEmbed;
